module.exports = "/**\n * @ORM\\Entity(repositoryClass=\"App\\Repository\\MovieRepository\")\n * @ORM\\Table(name=\"movie\")\n */\nclass Movie"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/entity-movie-repo.txt
// module id = 639
// module chunks = 166022795811749